export default "__VITE_ASSET__BzQ$w$D5__"